var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{ref:"span",tag:"domel",staticClass:"rest-placeholder"},[_vm._v(_vm._s(_vm.getString(_vm.strName)))])}
var staticRenderFns = []

export { render, staticRenderFns }